import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

export const groupFromBE = (group: any) =>
	group
		? {
				...group,
				service: group.service_id,
				service_template: group.service_template_id,
			}
		: group;

const BASE = '/cgCounselors';

export const getCgCounselors = async (query: ITableDataQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createCgCounselors = async (data: any) => backend.post(`${BASE}`, data);

export const getCgCounselor = async (id: number) => backend.get(`${BASE}/${id}`);

export const getCgCounselorProducts = async (id: number, query?: ITableDataQuery) =>
	backend.get(`${BASE}/${id}/products`, { params: query });

export const removeCgCounselor = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveCgCounselor = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);
